export const EU = 'EU'
export const US = 'US'
export const AS = 'AS'
export const UK = 'UK'
export const CA = 'CA'

export type Region = typeof EU | typeof US | typeof AS | typeof UK | typeof CA

export default [EU, US, AS, UK, CA]